import { formatearFechaLuxon } from "../../utils/formatearFecha"
import Documento from "../domain/Documento"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class DocumentoService {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  mostrarTipoFactura = (tipoFactura) => {
    switch (tipoFactura) {
      case "FCJ": return "Factura"
      case "CDJ": return "Contestación Demanda"
      default: return ""
    }
  }

  async getDocumentosObservacion(idObservacion) {
    let listadoDocumentos
    try {
      const body = {
        "sector": "legales/sipe/documentos",
        "identificador": idObservacion && idObservacion.toString()
      }

      const DocData = await this.apiService.fetchDocumentosDigitalizacion(body)

      listadoDocumentos = DocData && DocData.documentos.map(
        (documento) =>
          new Documento(
            DocData.baseUri,
            documento.sector,
            documento.internal,
            documento.archivo,
            documento.autor,
            documento.contentType,
            documento.extension,
            documento.fechaCreado,
            documento.path,
            documento.identifier,
            documento.fileSize,
            documento.tipoCodigo,
            documento.tipo,
            false,
            "Digitalizacion"
          )
      )

    } catch (err) {
      listadoDocumentos = [{}]
    }
    return listadoDocumentos
  }

  async getDocumentosFactura(idFactura) {
    let listadoDocumentos
    try {
      const body = {
        "sector": "legales/facturasjuicio",
        "identificador": idFactura && idFactura.toString()
      }

      const DocData = await this.apiService.fetchDocumentosDigitalizacion(body)

      listadoDocumentos = DocData && DocData.documentos.map(
        (documento) =>
          new Documento(
            DocData.baseUri,
            documento.sector,
            documento.internal,
            documento.archivo,
            documento.autor,
            documento.contentType,
            documento.extension,
            documento.fechaCreado,
            documento.path,
            documento.identifier,
            documento.fileSize,
            documento.tipo,
            this.mostrarTipoFactura(documento.tipoCodigo),
            false,
            "Digitalizacion"
          )
      )

    } catch (err) {
      listadoDocumentos = [{}]
    }
    return listadoDocumentos
  }

  async getDocumentosJuicioS3(idJuicio) {
    let listadoDocumentos
    try {
      const body =
      {
        "pageNumber": 1,
        "pageSize": 5,
        "filters": {
          "NroJuicio":  idJuicio && idJuicio.toString()
        },
        "orderCriteria": {
          "column": "",
          "order": "",
          "value": ""
        }
      }

      const DocData = await this.apiService.fetchDocumentosJuicioReingenieria(body)

      listadoDocumentos = DocData && DocData.juicioDocumentosResponse.items.map(
        (documento) =>
          new Documento(
            undefined,
            "legales/juicios/documentos",
            documento.id,
            documento.nombreArchivo,
            undefined,
            "application/pdf",
            ".pdf",
            documento.fecha,
            documento.urlPath,
            documento.id,
            0,
            documento.tipoDocumento,
            documento.tipoDocumento,
            false,
            "Digitalizacion"
          )
      )

    } catch (err) {
      listadoDocumentos = [{}]
    }
    return listadoDocumentos
  }

  async getDocumentosJuicioThuban(idJuicio) {
    let listadoDocumentos
    try {
      const DocData = await this.apiService.fetchDocumentosJuicio(idJuicio)

      listadoDocumentos = DocData && DocData.map(
        (documento) =>
          new Documento(
            documento.store_File_Path,
            documento.index_Item_Class,
            documento.index_Item_Id,
            documento.index_Item_Id + "_" + documento.tipo_Documento + "." + documento.store_File_Type,
            documento.usuario_Piscys,
            documento.store_File_Type,
            documento.store_File_Type,
            documento.fecha_Hora_Dig,
            documento.store_File_Path,
            documento.index_Item_Id,
            documento.store_File_Size,
            documento.codigo_Tipo_Documento,
            documento.tipo_Documento,
            true,
            "juicios"
          )
      )

    } catch (err) {
      listadoDocumentos = [{}]
    }
    return listadoDocumentos
  }

  async getDocumentosJuicioPorId(idDocumento) {
    let response
    try {
      response = await this.apiService.fetchDocumentoJuicioPorId(idDocumento)
    } catch (err) {
      response = [{}]
    }
    return response
  }


  async getDocumentosSiniestro(nroSiniestro) {
    let listadoDocumentos
    try {
      const DocData = await this.apiService.fetchDocumentosSiniestro(nroSiniestro)
 
      listadoDocumentos = DocData && DocData.map(
        (doc) =>
          new Documento(
            doc.baseUri,
            doc.descripcion,
            doc.id,
            doc.documento.origen==="thuban" ? doc.id + "_" + doc.tipoDocumentoDigital.descripcion + "." + doc.documento.extension : doc.baseUri + "/" + doc.path,
            doc.usuarioId,
            doc.documento.contentType,
            doc.documento.extension,
            formatearFechaLuxon(doc.fechaDigitalizacion,"dd/MM/yyyy"),
            doc.documento.path,
            doc.id,
            doc.documento.fileSize,
            doc.documento.tipoCodigo,
            doc.documento.tipo,
            doc.documento.origen==="thuban"?true:false,
            "siniestros"
          )
      )
 
    } catch (err) {
      console.error(err)
      listadoDocumentos = [{}]
    }
    return listadoDocumentos
  }

  async getDocumentosSiniestroPorId(idDocumento) {
    let response
    try {
      response = await this.apiService.fetchDocumentoSiniestroPorId(idDocumento)
    } catch (err) {
      response = [{}]
    }
    return response
  }

  async eliminartDocumento(sector, internalId) {

    const resultado = await this.apiService.fetchEliminarDocumento(sector, internalId)

    return resultado
  }

  async getTiposDocumento() {
    let response
    try {
      var responseTiposDoc = await this.apiService.fetchTiposDocumento()

      response = responseTiposDoc.tipos
        .filter((e) => e.sector === "legales/sipe/documentos")
        .sort((a, b) => a.descripcion.localeCompare(b.descripcion));

    } catch (err) {
      response = [{}]
    }
    return response
  }



}

export default DocumentoService
